import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput} from '../../components'
import container from '../../helpers/container'

import Styles from './About.css'

@CSSModules(Styles)
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'About'
    const url = config.domain + config.routes.about

    const bannerImage = 'park'
    const bannerHeadline = 'About Prison Free Funds'
    const bannerSubtitle = 'You can invest your values'

    // const aysLogo = require( '../../../static/images/' )
    const iyvLogo = require( '../../../static/images/iyv-logo-project-of-2021.jpg' )

    return (
      <div>
        {container.helmet(title, '', url)}
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>
                  {bannerHeadline}
                </div>
                { /* <div styleName='image-banner-subtitle'>
                  {bannerSubtitle}
                </div> */ }
              </div>
            </div>
          </div>
        </div>
        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='lede'>
                <strong>You may be invested in the prison industrial complex.</strong> You do not need to be a financial expert to know how much of your money is invested in morally problematic and unjust companies. 
              </div>
              <div styleName='title'>
                What is the prison industrial complex?
              </div>
              <div styleName='lede'>
                The <Link to={'http://criticalresistance.org/about/not-so-common-language/'} title='What is the prison industrial complex? What is abolition? | Critical Resistance' xstrong>prison industrial complex</Link> is a term used to describe the overlapping interests of government and industry that use surveillance, policing, and imprisonment as solutions to economic, social and political problems. On <strong>Prison Free Funds</strong>, we focus on two aspects of the prison industrial complex: companies involved in the prison industry (such as private for-profit prison operators and prison services providers), and companies involved in the militarization of borders and the policing of immigration.
              </div>
              <div styleName='title'>
                Look inside mutual funds
              </div>
              <div styleName='lede'>
                <strong>Prison Free Funds</strong> helps you find out if your money, in the form of mutual fund investments or an employer-provided 401(k), is being used to finance mass incarceration, private prison operators, immigrant detention and surveillance, or the border militarization industry. This free online tool can help you find alternative options to incarceration-based investments.
              </div>
              { /* <div styleName='lede'>
                We can help build a more just world by reducing the power of those who profit from the prison industrial complex. Investors have the power to divest from the corporations that profit from these unjust systems, and can reinvest in companies that support the movement for a more equitable future for all communities.
              </div> */ }
              <div styleName='title'>
                Who we are
              </div>
              <div styleName='lede'>
                For nearly three decades, As You Sow has promoted sustainable investing. As part of our <Link to={config.links.aysinvest} xstrong={true} title='As You Sow - Invest Your Values'>Invest Your Values program</Link>, we've created a series of tools that provide free information helping individuals do just that. 
              </div>
              <div styleName='double-logo-wrap'>
                <div styleName='double-logo'>
                  <div styleName='logo-second-wrap'>
                    <Link
                      to={config.links.aysinvest}
                      title='Invest Your Values - a project of As You Sow'
                      >
                      <img
                        styleName={'logo-ays'}
                        src={iyvLogo}
                        alt='Invest Your Values - a project of As You Sow'
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div styleName='title'>
                How Prison Free Funds works
              </div>
              <div styleName='lede'>
                <ul>
                  <li>Look up mutual funds using up-to-date investment data</li>
                  <li>We analyze your investments for private prison operators and other companies involved in the prison and border industries</li>
                  <li>See each fund's prison industrial complex grade</li>
                  <li><Link to={config.routes.toolkit} alt='Prison Free Action Toolkit | Prison Free Funds' xstrong>Use our action toolkit</Link> to push your employer to add sustainable funds to your 401(k) plan</li>
                </ul>
                <p>
                  <Link
                    to={config.routes.howitworks}
                    title='How it works'
                    roundbutton
                  >
                      Methodology<LinkIcon />
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <GetStartedInput />
        </div>
      </div>
    )
  }
}
